module.exports = __webpack_public_path__ + "img/Cademi-2-en.57723450.png";